import styled, { css } from 'styled-components';
import { breakpointMax } from '../../../foundation/theme/breakpoints.utils';
import { getSpace } from '../../../foundation/theme/space.utils';
// styled-components.
// -----------------------------------------------------------------------------
export const StackRoot = styled.div `
  ${({ theme, gap, direction }) => {
    return css `
      display: flex;
      flex-direction: ${direction};
      gap: ${getSpace(gap)};

      ${breakpointMax({
        breakpoint: 'm',
        rules: css `
          flex-direction: column;
        `,
        theme
    })}
    `;
}}

  ${({ alignment }) => {
    return (alignment &&
        css `
        align-items: ${alignment};
      `);
}}

  ${({ contentAlign }) => {
    return (contentAlign &&
        css `
        justify-content: ${contentAlign};
      `);
}}

  ${({ _wrap }) => {
    return (_wrap &&
        css `
        flex-wrap: wrap;
      `);
}}
`;
export const StackItemRoot = styled.div ``;
//# sourceMappingURL=Stack.styled.js.map